import { format} from "date-fns";
import { sv } from "date-fns/locale";

export const formatDate = (date:Date, formatStr:string) => {
  return format(date, formatStr, { locale: sv });
};

/** "2026-10-04" -> that day at local midnight; empty or unreadable -> null. */
export const parseIsoDay = (value?: string | null): Date | null => {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  return new Date(`${value}T00:00:00`);
};

export const formatToIsoDate = (date: Date): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", { locale: sv });
};

/**
 * Whether two dates fall on the same calendar day.
 *
 * Comparing getDay() only matches the weekday, so Monday next week counts as
 * today; comparing getDate() only matches the day of the month, so the 3rd of
 * next month does too. Compare the whole date.
 */
export const isSameDay = (a: Date, b: Date): boolean =>
  format(a, "yyyy-MM-dd") === format(b, "yyyy-MM-dd");

export const isToday = (date: Date): boolean => isSameDay(date, new Date());
